import Image from '@atoms/Image';
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import db from '@services/firebase-service';
import Text from '@atoms/Text';

const CommentOverlay = ({ streamId, isStopped, featureSettings, previewOverlayComments }) => {
  const startTime = new Date().getTime();

  const [overlayComments, setOverlayComments] = useState([]);
  const [comment, setComment] = useState();
  const [timerId, setTimerId] = useState();

  const handleStreamError = (reason) => {
    // eslint-disable-next-line no-console
    console.error('OverlayComponent stream error: ', reason);
  };

  useEffect(() => {
    if (timerId) {
      clearInterval(timerId);
    }
    if (overlayComments.length === 0) {
      return undefined;
    }

    setComment(overlayComments.shift());
    let index = 0;
    let interval;
    if (overlayComments.length === 10) {
      interval = 250;
    } else if (overlayComments.length > 4) {
      interval = 500;
    } else {
      interval = 3000;
    }
    setTimerId(setInterval(() => {
      setComment(overlayComments[index]);
      index += 1;
    }, interval));

    return () => { clearInterval(timerId); };
  }, [overlayComments]);

  useEffect(() => {
    let unsubscribe;
    if (!previewOverlayComments && featureSettings?.CommentsOverlay && !isStopped) {
      unsubscribe = onSnapshot(doc(db, 'overlay', streamId), (overlayDoc) => {
        if (overlayDoc.exists()) {
          const data = overlayDoc.data();
          if (data.error) {
            handleStreamError();
            return;
          }
          if (startTime && data.updatedAt > startTime) {
            setOverlayComments(data.data);
          }
        }
      });
    }
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (previewOverlayComments && featureSettings?.CommentsOverlay && !isStopped) {
      setOverlayComments((prevComments) => [...prevComments, ...previewOverlayComments]);
    }
  }, [previewOverlayComments]);

  return <>
    {comment && <div className='w-64 absolute bottom-24 z-50 right-2 rounded-[16px] p-4 bg-grey-100/40 backdrop-blur-lg shadow-md'>
      <div className='flex items-center mb-1'>
        <div className="w-6 h-6 bg-grey-900 rounded-full flex shrink-0">
          {comment?.profileImage
            ? <Image src={comment.profileImage} className='w-6 h-6 ' />
            : <Text className="text-sm font-medium text-white m-auto uppercase">{comment.name.charAt(0)}</Text>
          }
        </div>
        <Text className="text-grey-900 font-semibold text-sm leading-3.5 truncate pl-2">{comment.name}
        </Text>
      </div>
      <Text className="text-grey-900 font-medium text-sm font-normal line-clamp-2 pl-8">{comment.comment}</Text>
    </div>}
  </>;
};

export default CommentOverlay;
